export default "__VITE_ASSET__Bs2y0rm0__"